import React from 'react';
import { Box, Typography } from '@mui/material';

const ResultsQuotationHeader = ({ title, description }) => {
  return (
    <Box sx={{ mb: 2 }}>
      {title && (
        <Typography
          variant="h1"
          sx={{
            color: '#11354B',
            fontFamily: 'var(--font-red-hat-display)',
            fontSize: 'clamp(1.8rem, 0.9278rem + 1.831vw, 3.125rem)',
            fontWeight: 'bold',
            px: 4,
            textDecoration: 'none !important',
            textAlign: 'center',
            mb: 4,
          }}>
          {title}
        </Typography>
      )}
      {description && (
        <Typography
          sx={{
            color: '#11354B',
            fontFamily: 'var(--font-red-hat-display)',
            fontSize: 'clamp(1.125rem, 0.971rem + 0.593vw, 1.5625rem)',
            px: 4,
            textDecoration: 'none !important',
            textAlign: 'center',
            mb: 4,
          }}>
          {description}
        </Typography>
      )}
    </Box>
  );
};

export default ResultsQuotationHeader;
